






import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AdminTab from "./AdminTab.vue";

@Component({
  name: "admin",
  components: {
    AdminTab
  }
})
export default class Admin extends Vue {
  // Lifecycle Functions
  mounted() {
    this.$store.dispatch("admin/getUsers");
    this.$store.dispatch("admin/getCompanies");
    this.$store.dispatch("admin/getStores");
    this.$store.dispatch("admin/getRefreshTokens");
    this.$store.dispatch("admin/getAllowedUsers");
  }

  // Getters

  // Watchers
}
